export var Version;
(function (Version) {
    Version[Version["v1"] = 1] = "v1";
})(Version || (Version = {}));
